import * as React from 'react';

import AskAiTypeahead from 'src/components/dashboard/askai-typeahead';

import css from './dashboard-v2.css';

// ponytail: home renovation v2; gated behind homepageV2 flag in src/reroutes/app.tsx.
// Chips + AI Team + Your Metrics sections land in follow-up changes.
function DashboardV2(): React.ReactElement {
  return (
    <div className={css.dashboard} data-qa-id="dashboard-v2">
      <AskAiTypeahead />
    </div>
  );
}

export default DashboardV2;
